import React, { useState, useEffect } from 'react';
import api from '../services/api';

const RGSReportPage = () => {
  const [loading, setLoading] = useState(false);
  const [rgsData, setRgsData] = useState([]);
  const [error, setError] = useState(null);
const [selectedQuarter, setSelectedQuarter] = useState('all');
  const handleBackClick = () => {
    window.history.back();
  };

  // Fetch RGS data
  const fetchRGSData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const authToken = localStorage.getItem('authToken');
      
      const response = await fetch(`${api.BASE_URL}/project/report/infra/rgs`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('RGS API Response:', result);
        setRgsData(result.data || []);
      } else {
        throw new Error('Failed to fetch RGS data');
      }
    } catch (error) {
      console.error('Error fetching RGS data:', error);
      setError('Failed to load RGS report data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchRGSData();
  }, []);

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return new Date(dateString).toLocaleDateString('en-IN');
    } catch {
      return dateString;
    }
  };

  // Format currency helper
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '-';
    return new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    }).format(parseFloat(amount));
  };
// Filter data based on selected quarter
const getFilteredData = () => {
  if (selectedQuarter === 'q1') {
    return rgsData.filter(row => row.year && row.year === '25-26');
  } else if (selectedQuarter === 'q2') {
    return rgsData.filter(row => row.year && row.year === '25s26');
  }
  return rgsData;
};
  // Get latest stage info from stage_data array
  const getLatestStage = (stageData) => {
    if (!stageData || !Array.isArray(stageData) || stageData.length === 0) {
      return { status: '-', remarks: '-' };
    }
    
    const latestStage = stageData[stageData.length - 1];
    
    // Format status to readable text
    const statusMap = {
      'not_started': 'Not Started',
      'tendered': 'Tendered',
      'work_order_issued': 'Work Order Issued',
      'work_in_progress': 'Work in Progress',
      'physically_completed': 'Physically Completed',
      'completed_and_bill_paid': 'Completed & Bill Paid'
    };
    
    return {
      status: statusMap[latestStage.status] || latestStage.status || '-',
      remarks: latestStage.remarks || latestStage.tenderedRemarks || latestStage.workOrderRemarks || latestStage.expenditureRemarks || latestStage.physicallyCompletedRemarks || '-'
    };
  };

const downloadExcel = () => {
  const filteredData = getFilteredData();
  
  if (filteredData.length === 0) {
    alert('No data available to download');
    return;
  }

  const headers = [
    'Sl.No',
    'Scheme',
    'Center',
    'Year',
    'Title',
    'Type',
    'Units',
    'AS Date',
    'AS Number',
    'Amount (Rs)',
    'Current Stage',
    'Remarks'
  ];

  const csvRows = [headers.join(',')];

  filteredData.forEach((row, index) => {
    const stage = getLatestStage(row.stage_data);
    const values = [
      index + 1,
      `"${(row.scheme || '-').replace(/"/g, '""')}"`,
      `"${(row.center || '-').replace(/"/g, '""')}"`,
      `"${(row.year || '-').replace(/"/g, '""')}"`,
      `"${(row.title || '-').replace(/"/g, '""')}"`,
      `"${(row.type || '-').replace(/"/g, '""')}"`,
      row.units || '-',
      formatDate(row.as_date),
      `"${(row.as_number || '-').replace(/"/g, '""')}"`,
      row.amount || 0,
      `"${stage.status.replace(/"/g, '""')}"`,
      `"${stage.remarks.replace(/"/g, '""')}"`
    ];
    csvRows.push(values.join(','));
  });

  const csvContent = '\uFEFF' + csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
const quarterSuffix = selectedQuarter === 'q1' ? '_Q1_25-26' : selectedQuarter === 'q2' ? '_Q2_25s26' : '';
  
  link.setAttribute('href', url);
  link.setAttribute('download', `RRGSA_Infrastructure_Works_Report${quarterSuffix}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
      
      
        <div className="flex gap-3">
          <button
            onClick={fetchRGSData}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200 disabled:bg-blue-300 disabled:cursor-not-allowed"
          >
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
<div className="flex gap-2">
  <select
    value={selectedQuarter}
    onChange={(e) => setSelectedQuarter(e.target.value)}
    className="px-3 py-2 bg-white border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
    disabled={loading || rgsData.length === 0}
  >
    <option value="all">All Data</option>
    <option value="q1">1st Quarter (25-26)</option>
    <option value="q2">2nd Quarter (25s26)</option>
  </select>
  <button
    onClick={downloadExcel}
    disabled={loading || rgsData.length === 0}
    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors duration-200 disabled:bg-green-300 disabled:cursor-not-allowed flex items-center gap-2"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
    Download Excel
  </button>
</div>
        </div>
      </div>

      {/* Loading indicator */}
      {loading && (
        <div className="text-center mb-6 p-4 bg-blue-50 rounded-lg">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-3 text-blue-700 font-medium">Loading RRGSA report data...</p>
        </div>
      )}

      {/* Error message */}
      {error && (
        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-700">{error}</p>
        </div>
      )}

      {/* Review of RRGSA Infrastructure Works */}
      <div className="mb-8 bg-white rounded-lg shadow-sm overflow-hidden">
        <div className="bg-green-200 px-4 py-3">
          <h2 className="text-lg font-semibold text-center text-gray-800">Review of RRGSA Infrastructure Works - In SIRD & RIRD & PRs</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Sl.No</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Scheme</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Center</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Year</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Title</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Type</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">Units</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">AS Date</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700">AS Number</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 bg-orange-100">Amount (Rs.)</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 bg-orange-100">Current Stage</th>
                <th className="border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 bg-orange-100">Remarks</th>
              </tr>
            </thead>
            <tbody>
        {getFilteredData().length > 0 ? getFilteredData().map((row, index) => {
                const stage = getLatestStage(row.stage_data);
                return (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-3 py-2 text-sm text-center">{index + 1}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{row.scheme || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{row.center || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{row.year || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{row.title || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{row.type || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm text-center">{row.units || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{formatDate(row.as_date)}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm">{row.as_number || '-'}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm bg-orange-50 text-right font-semibold">{formatCurrency(row.amount)}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm bg-orange-50">{stage.status}</td>
                    <td className="border border-gray-300 px-3 py-2 text-sm bg-orange-50">{stage.remarks}</td>
                  </tr>
                );
              }) : (
                <tr>
                  <td colSpan="12" className="border border-gray-300 px-3 py-8 text-sm text-center text-gray-500">
                  {loading ? 'Loading...' : selectedQuarter !== 'all' ? 'No data available for selected quarter' : 'No RRGSA works data available'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};

export default RGSReportPage;